"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = require("../actions/ActionTypes");

var _AllCollectionsResults = _interopRequireWildcard(require("../records/AllCollectionsResults"));

var _SearchResult = _interopRequireDefault(require("../records/SearchResult"));

var initialState = new _AllCollectionsResults.default();

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED:
      {
        var collection = action.meta.collection;
        return (0, _AllCollectionsResults.getDedupedAllCollectionsResults)(state.set(collection, new _SearchResult.default(action.payload)));
      }

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/allCollectionsResults.js
// module id = 635
// module chunks = 209 210 211 212